import styled from '@emotion/styled';
import {
  Button,
  Column,
  Form,
  theme,
  device,
  useMedia,
} from '@landsbankinn/ui';
import React from 'react';
import { Title } from '../../book-appointment/shared/Title';

const TitleColumn = styled(Column)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`;

const BackButton = styled(Button)`
  width: 100%;
  display: flex;
  align-self: flex-start;
  margin-top: 24px;
  @media ${device.tablet} {
    width: initial;
    margin-top: 0px;
  }
`;

interface IProps {
  onSubmit: () => void;
  onBack: () => void;
  children: React.ReactNode;
  title: string;
  copy: string;
}

export function FormContainer({
  onBack,
  onSubmit,
  children,
  title,
  copy,
}: IProps) {
  const isMobile = useMedia('sm');
  return (
    <>
      <TitleColumn
        sm={{ offset: 1 / 12, width: 10 / 12 }}
        md={{ width: 4 / 12, offset: 1 / 12, offsetRight: 2 / 12 }}
      >
        <span>
          <Title
            title={title !== '' ? title : 'Panta tíma'}
            subTitle={
              copy !== ''
                ? copy
                : 'Sérfræðingar okkar taka vel á móti þér í viðtalstíma. Veldu þá þjónustu sem hentar þér.'
            }
          />
        </span>
        {!isMobile && (
          <BackButton
            title="Til baka"
            onClick={onBack}
            bordered
            bg={theme.colors.primary}
          />
        )}
      </TitleColumn>
      <Column
        sm={{ width: 10 / 12, offset: 1 / 12 }}
        md={{ width: 4 / 12, offsetRight: 1 / 12 }}
        style={{ position: 'relative' }}
      >
        <StyledForm onSubmit={onSubmit}>
          {children}
          {isMobile && (
            <BackButton
              title="Til baka"
              onClick={onBack}
              bordered
              bg={theme.colors.primary}
            />
          )}
        </StyledForm>
      </Column>
    </>
  );
}
